const actions = {
  //QR User
  GET_QR_USERS_REQUEST: "GET_QR_USERS_REQUEST",
  GET_QR_USERS_SUCCESS: "GET_QR_USERS_SUCCESS",

  DELETE_QR_USER_REQUEST: "DELETE_QR_USER_REQUEST",
  DELETE_QR_USER_SUCCESS: "DELETE_QR_USER_SUCCESS",

  UPDATE_QR_USER: "UPDATE_QR_USER",

  SAVE_QR_USER_REQUEST: "SAVE_QR_USER_REQUEST",
  SAVE_QR_USER_SUCCESS: "SAVE_QR_USER_SUCCESS",

  CREATE_QR_USER_REQUEST: "CREATE_QR_USER_REQUEST",
  CREATE_QR_USER_SUCCESS: "CREATE_QR_USER_SUCCESS",

  // QR Management
  GET_QR_TABLES_REQUEST: "GET_QR_TABLES_REQUEST",
  GET_QR_TABLES_SUCCESS: "GET_QR_TABLES_SUCCESS",

  // SELECT_VIDEO_DEVICE: "SELECT_VIDEO_DEVICE",

  SCAN_QR_TABLE_REQUEST: "SCAN_QR_TABLE_REQUEST",
  SCAN_QR_TABLE_SUCCESS: "SCAN_QR_TABLE_SUCCESS",

  UPDATE_SCANNED_QR_TABLE: "UPDATE_SCANNED_QR_TABLE",

  SAVE_QR_TABLE_REQUEST: "SAVE_QR_TABLE_REQUEST",
  SAVE_QR_TABLE_SUCCESS: "SAVE_QR_TABLE_SUCCESS",

  CREATE_QR_TABLE_REQUEST: "CREATE_QR_TABLE_REQUEST",
  CREATE_QR_TABLE_SUCCESS: "CREATE_QR_TABLE_SUCCESS",

  DELETE_QR_TABLE_REQUEST: "DELETE_QR_TABLE_REQUEST",
  DELETE_QR_TABLE_SUCCESS: "DELETE_QR_TABLE_SUCCESS",

  NEW_SCAN: "NEW_SCAN",

  SET_TABLE_STATUS_REQUEST: "SET_TABLE_STATUS_REQUEST",
  SET_TABLE_STATUS_SUCCESS: "SET_TABLE_STATUS_SUCCESS",

  TOGGAL_SCAN_QR_MODAL: "TOGGAL_SCAN_QR_MODAL",
  CHANGE_EXIST_QR_CODE: "CHANGE_EXIST_QR_CODE",

  GET_TOUCHSALE_TABLES_REQUEST: "GET_TOUCHSALE_TABLES_REQUEST",
  GET_TOUCHSALE_TABLES_SUCCESS: "GET_TOUCHSALE_TABLES_SUCCESS",

  GENERATE_QR_CODES_TXT_REQUEST: "GENERATE_QR_CODES_TXT_REQUEST",

  OPEN_QR_MODAL: "OPEN_QR_MODAL",

  //Actions

  generateQRTXT: (qrCodesCount) => {
    return (dispatch) => {
      dispatch({
        type: actions.GENERATE_QR_CODES_TXT_REQUEST,
        qrCodesCount,
      });
    };
  },

  getTouchSaleTables: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_TOUCHSALE_TABLES_REQUEST,
      });
    };
  },

  toggleScanModal: () => ({
    type: actions.TOGGAL_SCAN_QR_MODAL,
  }),

  changeExistQrCode: () => ({
    type: actions.CHANGE_EXIST_QR_CODE,
  }),

  dispatchSetTableStatus: (tableId, status) => {
    return (dispatch) => {
      dispatch({
        type: actions.SET_TABLE_STATUS_REQUEST,
        tableId,
        status,
      });
    };
  },

  createQRUser: (user) => {
    return (dispatch) => {
      dispatch({
        type: actions.CREATE_QR_USER_REQUEST,
        user,
      });
    };
  },

  deleteQRTable: (table) => {
    return (dispatch) => {
      dispatch({
        type: actions.DELETE_QR_TABLE_REQUEST,
        table,
      });
    };
  },

  newScan: () => {
    return (dispatch) => {
      dispatch({
        type: actions.NEW_SCAN,
      });
    };
  },

  createQRTable: (table) => {
    return (dispatch) => {
      dispatch({
        type: actions.CREATE_QR_TABLE_REQUEST,
        table,
      });
    };
  },

  saveQRTable: (table) => {
    return (dispatch) => {
      dispatch({
        type: actions.SAVE_QR_TABLE_REQUEST,
        table,
      });
    };
  },

  updateQRTable: (table, scanStatus) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_SCANNED_QR_TABLE,
        table,
        scanStatus,
      });
    };
  },

  scanQRTable: (guid) => {
    return (dispatch) => {
      dispatch({
        type: actions.SCAN_QR_TABLE_REQUEST,
        guid,
      });
    };
  },

  getQRTables: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_QR_TABLES_REQUEST,
      });
    };
  },
  getQRUsers: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_QR_USERS_REQUEST,
      });
    };
  },

  deleteQRUsers: (id) => {
    return (dispatch) => {
      dispatch({
        type: actions.DELETE_QR_USER_REQUEST,
        id,
      });
    };
  },

  updateQRUser: (user) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_QR_USER,
        user,
      });
    };
  },

  saveQRUser: (user) => {
    return (dispatch, getState) => {
      const users = getState().usersReducer.users;
      const index = users.map((org) => org.id).indexOf(user.id);
      users[index] = user;

      dispatch({
        type: actions.SAVE_QR_USER_REQUEST,
        users,
        user,
      });
    };
  },
};
export default actions;
